import React from "react";
import FormComponent from "../Form/FormComponent";
import { Dialog } from "@material-ui/core";
import { withStyles, Link } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {
  addLinkedinForm,
  customerLinkedinValidation,
} from "../Customers/CustomerConfig";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import "./AddLinkedin.css";
import store from "../../Redux/Store";
import { addorEditLinkedinProfile } from "../Customers/Customerquery";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose } = props;

  return (
    <MuiDialogTitle className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {},
}))(MuiDialogContent);

export default function CustomizedDialogs(props) {
  const [open, setOpen] = React.useState(
    props.showButton === false ? true : false
  );
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const renderModalContent = (props) => {
    return (
      <FormComponent
       
        formConfig={addLinkedinForm}
        modalClose={handleClose}
        mtitle="ADD_LINKEDIN"
        formValidation={customerLinkedinValidation}
        buttonName={"Save"}
        query={
          store.getState().isEditMode === true ? addorEditLinkedinProfile : ""
        }
        message="New Linkedin Profile added successfully"
       
      />
    );
  };

  return (
    <div>
      <Link
        onClick={handleClickOpen}
        style={{ cursor: "pointer", color: "#346beb" }}
      >
        Add More
      </Link>

      <div>
        <Dialog aria-labelledby="customized-dialog-title" open={open}>
          <div className="Linkedin">
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
              <div className="LinkedinTitle">Add Profile</div>
            </DialogTitle>
            <DialogContent>{renderModalContent(props)}</DialogContent>
          </div>
        </Dialog>
      </div>
    </div>
  );
}
